import { Component } from 'react';
import SurveyQuizcoverageInputLayout from './SurveyQuizCoverageInputLayout';

class SurveyQuizCoverageInput extends Component {
  render() {
    return (
      <SurveyQuizcoverageInputLayout 
        {...this.props} 
        {...this.state}
      />
    );
  }
}

export default SurveyQuizCoverageInput;
